import Typography from '@mui/material/Typography';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import useLogout from '../../../../hooks/useLogout';
import { RealMoneyStatus } from '../../../../types/status';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTCLI_IMPORTANT,
  TXTCLI_Logout,
  TXTSRV_If_you_require_further_assista_ELL,
  TXTWCL_It_was_determined_that_there_w_ELL,
  TXTWCL_Please_ensure_that_your_addres_ELL,
  TXTWCL_Please_noteX_You_will_not_be_a_ELL,
  TXTWCL_You_have_exhausted_the_maximum_ELL
} from './RMFValidationError.messages.json';
import { validationError } from './RMFValidationError.scss';

interface DkError {
  content: JSX.Element;
}

const getTranslations = (code: string) => {
  switch (code) {
    case RealMoneyStatus.DK_CPR_VALIDATION_ERROR:
      return {
        content: (
          <Typography>
            <Translation {...TXTWCL_It_was_determined_that_there_w_ELL} />{' '}
            <Translation {...TXTWCL_Please_ensure_that_your_addres_ELL} />{' '}
            <Translation {...TXTWCL_Please_noteX_You_will_not_be_a_ELL} />{' '}
            <Translation
              {...TXTSRV_If_you_require_further_assista_ELL}
              values={{
                a: (msg: React.ReactNode) => (
                  <ResolverLink
                    resolverTag={ResolverTag.HelpVerificationFaq}
                    options={{ query: { utm_id: 1 } }}
                  >
                    {msg}
                  </ResolverLink>
                )
              }}
            />
          </Typography>
        )
      };
    default:
      return {
        content: (
          <Typography>
            <Translation {...TXTWCL_You_have_exhausted_the_maximum_ELL} />
          </Typography>
        )
      };
  }
};

const RMFValidationError = () => {
  const logout = useLogout();
  const { error } = useWizardContext();
  const { code } = error?.globalErrors?.[0] || {};
  const displayValues: DkError = getTranslations(code ? code : '');

  return (
    <Container
      page={RMFValidationError}
      pageClassName={validationError}
      headerProps={{
        title: <Translation {...TXTCLI_IMPORTANT} />,
        buttons: {
          back: false
        }
      }}
      pageTopTitle={<Translation {...TXTCLI_IMPORTANT} />}
    >
      {displayValues.content}
      <CTAButton translation={TXTCLI_Logout} onClick={() => logout()} />
    </Container>
  );
};

RMFValidationError.displayName = 'RMFValidationError';

export default RMFValidationError;
